import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// REMOVE O OVERLAY DE ERRO DO REACT (CRA)
if (process.env.NODE_ENV === "development") {
    // Remove o overlay vermelho
    const style = document.createElement("style");
    style.innerHTML = `
      iframe, 
      #webpack-dev-server-client-overlay {
        display: none !important;
      }
    `;
    document.head.appendChild(style);

    // Não deixa o React Dev Server criar a tela
    window.$RefreshSig$ = () => {};
    window.$RefreshReg$ = () => {};
}

ReactDOM.render(
    <App />,
    document.getElementById('root')
);